/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react'
import ReactQuill from 'react-quill'
import './quill.snow.css'
import { DropdownItemProps, Form as SUIForm, Input, Select, TextArea } from 'semantic-ui-react'
import { noop } from '../../helpers/utils'
import { t } from '../../i18n/i18n'
import { FormInputError, InputFormProp } from './form'

// TODO for Kamil
export type FormInputProps = {
  errorSymbol?: string
  field: string
  form: InputFormProp<any, any>
  handleChange?: (...args: any[]) => any
  text?: string
  title?: string
  locked?: boolean
  type?: string
  icon?: React.ReactNode
  autoSubmit?: boolean
  size?: string
  fluid?: boolean
  placeholder?: string
  autoComplete?: string
  label?: React.ReactNode
  className?: string
  id?: string
  formats?: any
}

type FormInputState = any

export class FormInput<Props extends FormInputProps = FormInputProps> extends Component<Props, FormInputState> {
  static suiInputComponent: React.ComponentType = Input
  static supportsErrorProp = true

  handleChange = (_event: any, data: any) => {
    let value = data.value || data.checked
    if (value === undefined) value = '' // Stops defaults from overriding
    this.props.form?.updateValues({ [this.props.field]: value })
    this.props.handleChange && this.props.handleChange(value)
    this.props.autoSubmit && this.setState({}, this.props.form.submit || noop)
  }

  public currentValueProps(): Record<string, any> {
    let value = this.props.form?.values[this.props.field]
    if (value === undefined) {
      value = this.props.form?.defaults[this.props.field] || ''
    }
    return { value }
  }

  render() {
    const { field, id, text, errorSymbol, title, handleChange, autoSubmit, form, locked, className, ...suiInputProps } =
      this.props
    const InputComponent = (this.constructor as any).suiInputComponent
    const error = errorSymbol || form?.errors[field]
    const inputId = `input_${id ?? field}`

    return (
      <SUIForm.Field error={!!error} className={className}>
        {title && <label htmlFor={inputId}>{title}</label>}
        <InputComponent
          // TextArea does not support error attribute
          error={(this.constructor as any).supportsErrorProp ? !!error : undefined}
          className={this.props?.formats && 'quill-prose'}
          name={field}
          id={inputId}
          disabled={locked}
          {...(locked && { label: { icon: 'lock' }, labelPosition: 'right corner' })}
          onChange={this.handleChange}
          {...this.currentValueProps()}
          {...suiInputProps}
        />
        <FormInputError errorSymbol={error} />
        {text}
      </SUIForm.Field>
    )
  }
}

export class FormCheckbox extends FormInput {
  static suiInputComponent = SUIForm.Checkbox

  currentValueProps() {
    return { checked: !!super.currentValueProps().value }
  }
}

export class FormSelect extends FormInput<FormInputProps & { options: Array<DropdownItemProps> }> {
  // @FIXME problems with SemanticUITypings in the installed revision (remove casting once done)
  static suiInputComponent = Select as any
}

export class FormTextArea extends FormInput {
  static suiInputComponent = TextArea
  static supportsErrorProp = false
}

export class FormNumberInput extends FormInput {
  handleChange = (_event: any, data: any) => {
    this.props.form?.updateValues({
      [this.props.field]: data.value && data.value.replace(/\D/g, ''),
    })
  }
}

export class FormRichTextArea extends FormInput<
  FormInputProps & Pick<ReactQuill.ReactQuillProps, 'modules' | 'formats'>
> {
  static suiInputComponent = ReactQuill
  static supportsErrorProp = false

  currentValueProps() {
    return { defaultValue: super.currentValueProps().value }
  }

  handleChange = (html: any) => {
    this.props.form?.updateValues({
      [this.props.field]: html,
    })
  }
}

export const CountrySelect = ({ form, locked, ...props }: any) => {
  return (
    <FormSelect
      form={form}
      field="countryAlpha2"
      title={t('attributes.country')}
      fluid
      options={[
        { key: 1, text: t('country.de'), value: 'de' },
        { key: 2, text: t('country.at'), value: 'at' },
      ]}
      disabled={locked}
      {...props}
    />
  )
}
